<template>
  <div class="register container">
    <PageHeading heading="Registration"/>
    <br/>
    <div class="row alert confirmation alert-success" v-if="success">
      <div class="col-12">
          <h4>You registered the following:</h4>
      </div>
      <div class="col-md-3">
        
        <div class="container">
          <strong>Church:</strong> {{ team.church }} <br/>
          <strong>Team Name:</strong> {{ team.name }} <br/>
          <strong>Coach:</strong> {{ team.coach }} <br/>
          <strong>Division:</strong> {{ team.division }} <br/>
          <strong>Email:</strong> {{ team.email }} <br/>
          <strong>Phone:</strong> {{ team.phone }} <br/>
          <strong>Notes:</strong> {{ team.notes }} <br/>
          <strong>Lunch Count:</strong> {{ team.lunch }}
        </div>
      </div>
      <div class="col-md-4">
        <div class="container">
        <strong>Quizzers:</strong><br/>
          <span v-for="(quizzer, i) in team.quizzers" :key="quizzer.id">
           <strong>{{++i}}.</strong> {{ quizzer.name}} {{ quizzer.rookie ? '(Rookie)': ''}} <br/>
          </span>
        </div>
      </div>
    </div>
    <form class="row" ref="form" v-if="!success">
      <!-- BEGIN FIRST COLUMN OF FORM -->
      <div class="col-md-6 team">
        <div class="row g-3">
          <!-- Date -->
          <div class="col-md-12">
            <label for="date" class="form-label">Date <span>(REQUIRED)</span></label>
            <select id="date" class="form-select" v-model="team.date">
              <option disabled value="">Select a date</option>
              <option v-for="date in dates" :key="date.id" :value="date.date">{{fmtDate(date.date)}} at {{date.location}}</option>
            </select>
          </div>

          <!-- Church -->
          <div class="col-12">
            <label for="church_name" class="form-label">Church Name <span class="red" v-if="required(validChurchName)">(REQUIRED)</span></label>
            <input type="text" class="form-control" id="church_name" v-model="team.church" :class="validChurchName">
          </div>
            
          <!-- Team -->
          <div class="col-12">
            <label for="team_name" class="form-label">Team Name <span class="red" v-if="required(validTeamName)">(REQUIRED)</span></label>
            <input type="text" class="form-control" id="team_name" v-model="team.name" :class="validTeamName">
          </div>

          <!-- Division -->
          <div class="col-md-6">
            <label for="division" class="form-label">Division <span class="red" v-if="required(validDivisionSelected)">(REQUIRED)</span></label>
            <select id="division" class="form-select" v-model="team.division" :class="validDivisionSelected">
              <option value="">Select a division</option>
              <option>Novice</option>
              <option>Intermediate</option>
              <option>Expert</option>
            </select>
          </div>

          <!-- Coach -->
          <div class="col-md-6">
            <label for="coach_name" class="form-label">Coach <span class="red" v-if="required(validCoachName)">(REQUIRED)</span></label>
            <input type="text" class="form-control" id="coach_name" v-model="team.coach" :class="validCoachName">
          </div>

          <!-- Email -->
          <div class="col-md-6">
            <label for="email_address" class="form-label">Email <span class="red" v-if="required(validEmail)">(REQUIRED)</span></label>
            <input type="email" class="form-control" id="email_address" v-model="team.email" :class="validEmail">
          </div>

          <!-- Phone -->
          <div class="col-md-6">
            <label for="phone_number" class="form-label">Phone <span class="red" v-if="required(validPhone)">(REQUIRED)</span></label>
            <input type="tel" class="form-control" id="phone_number" v-model="team.phone" :class="validPhone">
          </div>

          <!-- Notes -->
          <div class="col-md-12">
            <label for="notes" class="form-label">Note <span>(OPTIONAL)</span></label>
            <textarea class="form-control" id="notes"  v-model="team.notes"></textarea>
          </div>

          <!-- Lunch Count -->
          <div class="col-md-4">
            <label for="lunch_count" class="form-label">Lunch Count <span>(REQUIRED)</span></label>
            <input type="number" class="form-control" id="lunch_count" v-model="team.lunch">
          </div>

        </div><!-- END FIRST COLUMN OF FORM-->
      </div><!-- END ROW OF FIRST COLUMN -->
    
      <div class="col-md-6 quizzers"><!-- BEGIN SECOND COLUMN OF FORM -->
        <div class="row g-3"><!-- BEGIN ROW OF SECOND COLUMN -->
          <!-- Quizzer 1 -->
          <div class="col-12 quizzer">
            <div class="row">
              <div class="col-md-8">
                <label for="quizzer_1" class="form-label">Quizzer 1 <span class="red" v-if="required(validQuizzerName)">(REQUIRED)</span></label>
                <input type="text" class="form-control" id="quizzer_1" v-model="team.quizzers[0].name" :class="validQuizzerName">
              </div>
              <div class="col-md-4 center-check d-flex align-items-end">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="quizzer_1_rookie" v-model="team.quizzers[0].rookie">
                  <label class="form-check-label" for="quizzer_1_rookie">Rookie</label>
                </div>
              </div>
            </div>
          </div>

          <!-- Quizzer 2 -->
          <div class="col-12 quizzer">
            <div class="row">
              <div class="col-md-8">
                <label for="quizzer_2" class="form-label">Quizzer 2 <span>(OPTIONAL)</span></label>
                <input type="text"  class="form-control" id="quizzer_2" v-model="team.quizzers[1].name">
              </div>
              <div class="col-md-4 center-check d-flex align-items-end">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="quizzer_2_rookie" v-model="team.quizzers[1].rookie">
                  <label class="form-check-label" for="quizzer_2_rookie">Rookie</label>
                </div>
              </div>
            </div>
          </div>
        
          <!-- Quizzer 3 -->
          <div class="col-12 quizzer">
            <div class="row">
              <div class="col-md-8">
                <label for="quizzer_3" class="form-label">Quizzer 3 <span>(OPTIONAL)</span></label>
                <input type="text" class="form-control" id="quizzer_3" v-model="team.quizzers[2].name">
              </div>
              <div class="col-md-4 center-check d-flex align-items-end">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="quizzer_3_rookie" v-model="team.quizzers[2].rookie">
                  <label class="form-check-label" for="quizzer_3_rookie">Rookie</label>
                </div>
              </div>
            </div>
          </div>

          <!-- Quizzer 4 -->
          <div class="col-12 quizzer">
            <div class="row">
              <div class="col-md-8">
                <label for="quizzer_4" class="form-label">Quizzer 4 <span>(OPTIONAL)</span></label>
                <input type="text" class="form-control" id="quizzer_4" v-model="team.quizzers[3].name">
              </div>
              <div class="col-md-4 center-check d-flex align-items-end">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="quizzer_4_rookie" v-model="team.quizzers[3].rookie">
                  <label class="form-check-label" for="quizzer_4_rookie">Rookie</label>
                </div>
              </div>
            </div>
          </div>

          <!-- Quizzer 5 -->
          <div class="col-12 quizzer">
            <div class="row">
              <div class="col-lg-8">
                <label for="quizzer_5" class="form-label">Quizzer 5 <span>(OPTIONAL)</span></label>
                <input type="text" class="form-control" id="quizzer_5" v-model="team.quizzers[4].name">
              </div>
              <div class="col-lg-4 center-check d-flex align-items-end">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="quizzer_5_rookie" v-model="team.quizzers[4].rookie">
                  <label class="form-check-label" for="quizzer_5_rookie">Rookie</label>
                </div>
              </div>
            </div>
          </div>
            
        </div><!-- END ROW OF SECOND COLUMN -->
      </div><!-- END SECOND COLUMN OF FORM -->
    </form>
    <div class="d-grid gap-2">
      <button class="btn btn-dark" type="button" @click="register" v-if="!success" :disabled="!formComplete">Register</button>
      <button class="btn btn-success" type="button" @click="registerNew" v-if="success">Register Another Team</button>
    </div>
    </div>

</template>

<script>
// @ is an alias to /src
import axios from "axios"
import PageHeading from '@/components/PageHeading.vue';

export default {
  name: 'Register',
  components: {
    PageHeading
  },
  data: function() {
    return {
      team: {
        date: '',
        church: '',
				name: '',
				coach: '',
				division: '',
				email: '',
				phone: '',
				lunch: 0,
				quizzers: [
          {name:'', rookie:false},
          {name:'', rookie:false},
          {name:'', rookie:false},
          {name:'', rookie:false},
          {name:'', rookie:false}
        ],
				notes: '',
      },
      success: false,
      dates: []
    }
  },
  created() {
    // Get the schedule to populate the dates for registration 
    axios.get(process.env.VUE_APP_API_ROOT + "/lib/schedule.php")
    .then((response) => {
      if(response.data !== null) {
        this.dates = response.data.map (a => {return {date: a.date, location: a.location}});
        
        // Find the nearest future date
        this.team.date = this.findNearest();
      }
    });

  },
  computed: {
    formComplete: function() {
      const v = "is-valid";
      return this.validChurchName == v 
              && this.validTeamName == v 
              && this.validCoachName == v 
              && this.validPhone == v 
              && this.validDivisionSelected == v 
              && this.validEmail == v 
              && this.validQuizzerName == v;
    },
    validChurchName: function() {
      return this.genericValidation(this.team.church);
    },
    validTeamName: function() {
      return  this.genericValidation(this.team.name);
    },
    validCoachName: function() {
      return  this.genericValidation(this.team.coach);
    },
    validPhone: function() {
      return !this.isNotBlank(this.team.phone) ? '' : /^\({0,1}[0-9]{3}\){0,1}[\s-]*[0-9]{3}-{0,1}[0-9]{4}\s*$/.test(this.team.phone) ? 'is-valid' : 'is-invalid';
    },
    validDivisionSelected: function() {
      return !this.isNotBlank(this.team.division) ? '' : ['Novice','Intermediate','Expert'].includes(this.team.division)  ? 'is-valid' : 'is-invalid';
    },
    validEmail: function() {
			// Stole this from Stackoverflow
			const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return !this.isNotBlank(this.team.email) ? '' : re.test(String(this.team.email).toLowerCase()) ? 'is-valid' : 'is-invalid';
		},
    validQuizzerName: function() {
      return  this.genericValidation(this.team.quizzers[0].name);
    },
  },
  methods: {
    isNotBlank: function(val) {
      return val && val.length > 0 ? true:false;
    },
    isValidName:  function(val,length) {
      return val && val.length >= length;
    },
    genericValidation: function(val) {
      return !this.isNotBlank(val) ? '' : this.isValidName(val,3) ? 'is-valid' : 'is-invalid';
    },
    required: function(val) {
      return val == "" || val == "is-invalid" ? true : false;
    },
    findNearest: function() {
      let now = new Date();
      // first set nearest date after 'now'
      let nearest = undefined;
      this.dates.forEach(function(d) {
       const date = new Date(d.date);
       if (date >= now) {
          nearest = d.date;
          now = new Date("2100-01-01");
        }
      })
      return nearest;
    },
    removeBlankQuizzers: function(team) {
      // Spread operator copies since Javascript is pass by reference.
      let teamCopy = {...team}; 
      let quizzers = [];
      
      teamCopy.quizzers.forEach( (quizzer) => {
        if (quizzer.name != '' && quizzer.name.length >= 2) {
          quizzers.push(quizzer);
        } 
      })
      teamCopy.quizzers = quizzers;
      return teamCopy;
    },
    register: function() {
      let newTeam = this.removeBlankQuizzers(this.team);
      axios.post(process.env.VUE_APP_API_ROOT + '/lib/register.php', newTeam)
                .then((res) => {
                    console.log(res.data);
                    this.success = true;
                })
                .catch((error) => {
                    console.log(error);
                });
    },
    registerNew: function() {
      this.team.church = '';
      this.team.name = '';
      this.team.coach = '';
      this.team.division = '';
      this.team.email = '';
      this.team.phone = '';
      this.team.lunch = 0;
      this.team.quizzers = [
          {name:'', rookie:false},
          {name:'', rookie:false},
          {name:'', rookie:false},
          {name:'', rookie:false},
          {name:'', rookie:false}
        ]
      this.team.notes = '';
      this.success = false;
    }
  }
}
</script>

<style>
label > span {
  font-size: 75%;
  color: rgb(122, 122, 122)
}
.red {
  color: rgb(155, 0, 0);
  font-weight: bold;
}
form  {
  padding: 0 1em;
}

.quizzer {

  border-radius: 5px;
  background-color: #FBFBFB;
  padding: .5em;
  margin: 1em auto;
}

.quizzers {
  padding-top: .5em;
  background-color: #F9F9F9;
  margin-bottom: 1em;
}

.team {
  padding-top: 1em;
  background-color: #FBFBFB;
  border-right: 2px dotted #DADADA; margin-bottom: 1em;
}

.confirmation {
  margin: 1em 0;
}

.confirmation .container {
  padding-left: .5em;
} 
</style>